import { render, staticRenderFns } from "./CamposExtras.vue?vue&type=template&id=5464890f&"
import script from "./CamposExtras.vue?vue&type=script&lang=js&"
export * from "./CamposExtras.vue?vue&type=script&lang=js&"
import style0 from "./CamposExtras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports